<template>
  <div class="py-6 px-1 md:px-2 lg:px-6">
    <div class="mx-auto py-8 max-w-sm flex justify-center">
      <Link href="/">
        <AppLogo class="h-16 fill-black dark:fill-primary-500" />
      </Link>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Auth',
}
</script>
